const timer = {
  days: 'Jr{{plurial}}',
  hours: 'Hr{{plurial}}',
  minutes: 'Min{{plurial}}',
  seconds: 'Scd{{plurial}}',
  text: 'Lancement du Mall dans :',
}


export default timer
